import { createSlice } from "@reduxjs/toolkit";

const getInitialState = () => {
  const storedAdminDashboardTab = localStorage.getItem("adminDashboardTab");
  const adminDashboardTab = storedAdminDashboardTab ? parseInt(storedAdminDashboardTab) : 0;

  const storedAdminDirectoryTab = localStorage.getItem("adminDirectoryTab");
  const adminDirectoryTab = storedAdminDirectoryTab ? parseInt(storedAdminDirectoryTab) : 0;

  return {
    spinner: 0,
    language: "en",
    adminDashboardTab,
    adminDirectoryTab,
  };
};

const applicationSlice = createSlice({
  name: "application",
  initialState: getInitialState(),
  reducers: {
    setSpinner: (state, action) => {
      state.spinner = action.payload;
    },
    setLanguage: (state, action) => {
      state.language = action.payload;
    },
    setAdminDashboardTab: (state, action) => {
      state.adminDashboardTab = action.payload;
      localStorage.setItem("adminDashboardTab", action.payload.toString());
    },
    setAdminDirectoryTab: (state, action) => {
      state.adminDirectoryTab = action.payload;
      localStorage.setItem("adminDirectoryTab", action.payload.toString());
    },
  },
});

export const {
  setSpinner,
  setLanguage,
  setAdminDashboardTab,
  setAdminDirectoryTab,
} = applicationSlice.actions;
export default applicationSlice.reducer;
